import { IonImg } from '@ionic/react';
import React, { ReactNode } from 'react';

import { Spacer } from '@/components/common';
import { Icon } from '@/components/memo';

import './Promo.css';

interface PromoProps {
  containerStyle?: React.CSSProperties;
  icon?: string;
  iconColor?: string;
  image?: string | null;
  imageStyle?: React.CSSProperties;
  disableImageBloop?: boolean;
  enableImageFloat?: boolean;
  header?: ReactNode | string;
  subHeader?: ReactNode | string;
}

const Promo: React.FC<PromoProps> = ({
  containerStyle,
  icon,
  iconColor = 'primary',
  image,
  imageStyle = { maxWidth: 286 },
  disableImageBloop = false,
  enableImageFloat = false,
  header,
  subHeader
}) => {
  const bloop = (e: React.MouseEvent<HTMLIonImgElement, MouseEvent>) => {
    const imageElement = e.currentTarget;
    if (imageElement.classList.contains('bloop')) {
      return;
    }
    imageElement.classList.add('bloop');
    setTimeout(() => {
      imageElement.classList.remove('bloop');
    }, 1000);
  };

  return (
    <div className="promo" style={containerStyle}>
      {icon && !image && (
        <Icon className="promo__icon" icon={icon} color={iconColor} />
      )}
      {!icon && image && (
        <IonImg
          className={`promo__image ${enableImageFloat ? 'promo__image--float' : ''}`}
          src={image}
          style={imageStyle}
          onClick={!disableImageBloop ? bloop : undefined}
        />
      )}
      {header && (
        <Spacer top={42} bottom={16}>
          <h1 className="promo__header header-text">{header}</h1>
        </Spacer>
      )}
      {subHeader && <h3 className="promo__sub-header">{subHeader}</h3>}
    </div>
  );
};

export default Promo;
